import { handleGeneralErrors } from 'src/utils/error-handler';

/* ------- XỬ LÝ LỖI SAU KHI SUBMIT FORM ------ */
const fields: any = {
  oldPassword: 'Mật khẩu hiện tại',
  newPassword: 'Mật khẩu mới',
};
const fieldAlias: any = {
  oldPassword: 'oldPassword',
  newPassword: 'newPassword',
};
export function handleError(error: any, setError: any) {
  handleGeneralErrors(fields, fieldAlias, error, setError);
}
